import React from 'react';
import { connect } from 'react-redux';
import { content } from './selectors';
import PropTypes from '../../types';

export const Content = ({ content, children }) => children(content);

Content.propTypes = {
  id: PropTypes.string,
  content: PropTypes.oneOfType([PropTypes.string, PropTypes.objectOf(PropTypes.string)]).isRequired,
  children: PropTypes.func
};

const DefaultChildComponent = content => <span>{content}</span>;

Content.defaultProps = {
  children: DefaultChildComponent
};

const mapStateToProps = (state, { id }) => ({
  content: content(state, id)
});

export default connect(mapStateToProps)(Content);
